//
// App
//
// Main entry for the App, where we switch between loading, login, and project screens.

import { observer } from 'mobx-react-lite'
import { useStore } from './stores'

import { AppView } from './appview'
import { AppErrorScreen, ErrorBoundary } from './errors'
import {
    AccountScreen,
    InviteScreen,
    LoadingScreen,
    LoginScreen,
    ProjectScreen,
    SignUpScreen,
    WelcomeScreen,
} from './screens'

// Comments keep this import order intact, as CSS imports rely on order
/* eslint-disable import/order */
import './appview/appview.css'
//
import './components/components.scss'
//
import './site.scss'
//
import './app.scss'
//
import './workspaces/pim/worksheets/worksheets.scss'

export const App = observer(function App(props) {
    const store = useStore()

    let Screen = <LoadingScreen />
    // if (store.in_maintenance) {
    //     Screen = <MaintenanceScreen />
    // } else
    if (!store.is_loading) {
        if (store.location === store.LOCATIONS.WELCOME) {
            Screen = <WelcomeScreen />
        } else if (store.location === store.LOCATIONS.SIGNUP) {
            Screen = <SignUpScreen />
        } else if (store.location === store.LOCATIONS.LOGIN) {
            Screen = <LoginScreen />
        } else if (store.location === store.LOCATIONS.INVITE) {
            Screen = <InviteScreen />
        } else if (store.location === store.LOCATIONS.ACCOUNT) {
            Screen = <AccountScreen />
        } else if (store.location === store.LOCATIONS.PROJECT) {
            Screen = <ProjectScreen />
        }
    }

    return (
        <AppView
            onContextMenu={e => {
                if (!store.can('debug')) {
                    e.preventDefault()
                    e.stopPropagation()
                    e.nativeEvent.stopImmediatePropagation()
                }
            }}
        >
            <ErrorBoundary
                errorUI={AppErrorScreen}
                reportError={store.reportError}
                onReset={() => window.location.reload()}
            >
                {Screen}
            </ErrorBoundary>
        </AppView>
    )
})
